import React from 'react';
import { Modal } from 'react-bootstrap';
import { Membership as MembershipType } from 'types/membership';
import Button from 'components/Button';
import styles from '../Membership.module.scss';

function formatName(m: MembershipType) {
  const parts = [m.lastName, m.firstName].filter(Boolean);
  if (m.middleName) parts.splice(1, 0, m.middleName);
  return parts.join(', ') || '—';
}

function formatDate(value: string | undefined): string {
  if (!value) return '—';
  try {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
  } catch {
    return value;
  }
}

interface RollbackMembershipModalProps {
  show: boolean;
  onHide: () => void;
  snapshot: MembershipType | null;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

function RollbackMembershipModal({
  show,
  onHide,
  snapshot,
  onConfirm,
  isSubmitting = false,
}: RollbackMembershipModalProps) {
  if (!snapshot) return null;

  return (
    <Modal show={show} onHide={onHide} className={styles.modalDialog}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>
          Rollback membership
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>
          Are you sure you want to rollback to the version from{' '}
          <strong>{formatDate(snapshot.updatedAt)}</strong> (
          {formatName(snapshot)})?
        </p>
        <p className={styles.rollbackWarning}>
          This will create a new snapshot of the current state before applying
          the rollback.
        </p>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button variant="outline" onClick={onHide} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isSubmitting}>
          {isSubmitting ? 'Rolling back...' : 'Rollback'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RollbackMembershipModal;
